import React from 'react';
import { IconButton, IconButtonProps } from 'components/Buttons';
import * as Styled from './CollectionCarousel.styles';

type ScrollActionIcon = 'scrollPlay' | 'scrollPause';

export interface ScrollActionHandlerProps {
  onClick: IconButtonProps['onClick'];
}

export interface ScrollActionProps extends ScrollActionHandlerProps {
  icon: ScrollActionIcon;
}

const ScrollActionIconButton: React.FC<ScrollActionProps> = ({
  icon,
  onClick,
}) => {
  const iconName: IconButtonProps['iconName'] = icon;

  return (
    <Styled.ScrollAction>
      <IconButton
        onClick={onClick}
        size="small"
        color="secondary"
        iconName={iconName}
      />
    </Styled.ScrollAction>
  );
};

export const PlayActionIconButton: React.FC<ScrollActionHandlerProps> = ({
  onClick,
}) => <ScrollActionIconButton icon={'scrollPlay'} onClick={onClick} />;

export const PauseActionIconButton: React.FC<ScrollActionHandlerProps> = ({
  onClick,
}) => <ScrollActionIconButton icon={'scrollPause'} onClick={onClick} />;

export default ScrollActionIconButton;
